export default class AuthorizationHelper {
  public static permissionsPrefix = {
    index: 'manage_',
    show: 'read_',
    store: 'manage_',
    update: 'manage_',
    destroy: 'manage_',
    export: 'manage_',
    delete: 'manage_',
    recover: 'manage_',
    bulk_delete: 'manage_',
    bulk_destroy: 'manage_',
    bulk_recover: 'manage_',
    bulk_edit: 'manage_',
    bulk_cancel: 'manage_',
    bulk_message: 'manage_',
    bulk_add_to_team_or_group: 'manage_',
    bulk_store: 'manage_',
    bulk_subscription: 'manage_',
    bulk_coupon: 'manage_',
    export_all: 'manage_',
    pay: 'manage_',
    send: 'manage_',
    cancel: 'manage_',
    process: 'manage_', // TODO review this, it is something specific for invoiceSyncItems
    bulk_process: 'manage_', // TODO review this, it is something specific for invoiceSyncItems
    download: 'manage_', // TODO review this, it is something specific for invoiceSyncItems
    bulk_download: 'manage_', // TODO review this, it is something specific for invoiceSyncItems
    invoices_to_sync_items: 'manage_', // TODO review this, it is something specific for invoices
    tickets_to_invoice: 'manage_', // TODO review this, it is something specific for invoices
    pos_checkout: 'manage_',
    bulk_pos_checkout: 'manage_',
    buy: 'manage_',
    manage_accounts: 'manage_',
    request_contract: 'manage_',
    propose_contract: 'manage_',
    confirm_contract: 'manage_',
    cancel_contract: 'manage_',
    renew_contract: 'manage_',
    pay_attendee: 'manage_',
    cancel_booking: 'cancel_',
    tickets_to_direct_debit_file: 'manage_',
    edit_cash_movements: 'create_',
    pay_product: 'manage_',
  };
  public static fixedPermissions = {
    sections: {
      main: 'sidebar_section_main',
      communication: 'sidebar_section_communication',
      configuration: 'sidebar_section_configuration',
    },
    sidebar: {
      contacts: 'sidebar_contacts',
      price_categories: 'sidebar_price_categories',
      contact_relation_categories: 'sidebar_contact_relation_categories',
      contact_tags: 'sidebar_contact_tags',
      contact_relations: 'sidebar_contact_relations',
      documents: 'sidebar_documents',
      contracts: 'sidebar_contracts',
      bookings: 'sidebar_bookings',
      booking_events_calendar: 'sidebar_booking_events_calendar',
      booking_events: 'sidebar_booking_events',
      schedules: 'sidebar_schedules',
      slot_price_categories: 'sidebar_slot_price_categories',
      schedule_slot_ranges: 'sidebar_schedule_slot_ranges',
      disciplines: 'sidebar_disciplines',
      holidays: 'sidebar_holidays',
      periods: 'sidebar_periods',
      resources: 'sidebar_resources',
      access_points: 'sidebar_access_points',
      templates: 'sidebar_templates',
      center_settings: 'sidebar_center_settings',
      profiles: 'sidebar_profiles',
      sectors: 'sidebar_sectors',
      messages: 'sidebar_messages',
      activity_logs: 'sidebar_activity_logs',
      taxes: 'sidebar_taxes',
      accounts: 'sidebar_accounts',
      analytic_accounts: 'sidebar_analytic_accounts',
      article_tags: 'sidebar_article_tags',
      article_prices: 'sidebar_article_prices',
      article_true_costs: 'sidebar_article_true_costs',
      articles: 'sidebar_articles',
      activities: 'sidebar_activities',
      activity_groups: 'sidebar_activity_groups',
      activity_sessions: 'sidebar_activity_sessions',
      activity_session_attendees: 'sidebar_activity_session_attendees',
      enrollments: 'sidebar_enrollments',
      activity_categories: 'sidebar_activity_categories',
      orders: 'sidebar_orders',
      accounting_journals: 'sidebar_accounting_journals',
      invoices: 'sidebar_invoices',
      tickets: 'sidebar_tickets',
      codas: 'sidebar_codas',
      payments: 'sidebar_payments',
      subscription_categories: 'sidebar_subscriptions',
      subscriptions: 'sidebar_subscriptions',
      option_groups: 'sidebar_option_groups',
      post_categories: 'sidebar_post_categories',
      posts: 'sidebar_posts',
      widgets: 'sidebar_widgets',
      menu_entries: 'sidebar_menu_entries',
      certificates: 'sidebar_certificates',
      certificate_categories: 'sidebar_certificate_categories',
      invoice_sync_items: 'sidebar_invoice_sync_items',
      coupons: 'sidebar_coupons',
      mandates: 'sidebar_mandates',
      direct_debit_files: 'sidebar_direct_debit_files',
      terminals: 'sidebar_terminals',
      pos_boxes: 'sidebar_pos_boxes',
      pos_sessions: 'sidebar_pos_sessions',
      pos_incidents: 'sidebar_pos_incidents',
      media: 'sidebar_media',
      discount_categories: 'sidebar_discount_categories',
      entries: 'sidebar_entries',
      entry_categories: 'sidebar_entry_categories',
      superadmin_options: 'sidebar_superadmin_options',
      access_control_badges: 'sidebar_access_control_badges',
      access_control_events: 'sidebar_access_control_events',
      accesses_report: 'sidebar_accesses_report',
      accounting_reports: 'sidebar_accounting_reports',
      user_evolution: 'sidebar_user_evolution',
      sales_report: 'sidebar_sales_report',
      tax_certificates: 'sidebar_tax_certificates',
      customer_area_setting: 'sidebar_customer_area_setting',
      wallets: 'sidebar_wallets',
    },
  };
  public static getPermissionName(action: string, entityName: string, own = false) {
    const namePrefix = AuthorizationHelper.permissionsPrefix[action];
    if (namePrefix) {
      const ownPrefix = own ? 'own_' : '';
      return `${namePrefix}${ownPrefix}${entityName}`;
    }
    return action;
  }

  public static mockData() {
    const profiles = [
      {
        role: 'admin',
        permissions: [
          // Sidebar sections
          AuthorizationHelper.fixedPermissions.sections.main,
          AuthorizationHelper.fixedPermissions.sections.communication,
          AuthorizationHelper.fixedPermissions.sections.configuration,

          // Sidebar
          AuthorizationHelper.fixedPermissions.sidebar.contacts,
          AuthorizationHelper.fixedPermissions.sidebar.contracts,
          AuthorizationHelper.fixedPermissions.sidebar.documents,
          AuthorizationHelper.fixedPermissions.sidebar.bookings,
          AuthorizationHelper.fixedPermissions.sidebar.booking_events,
          AuthorizationHelper.fixedPermissions.sidebar.booking_events_calendar,
        ],
      },
    ];
    const entities = [
      'contacts',
      'documents',
      'contracts',
      'bookings',
      'booking_events',
      'messages',
    ];
    const actions = [
      'index',
      'show',
      'store',
      'update',
      'destroy',
      'delete',
      'recover',
      'bulk_destroy',
      'bulk_delete',
      'bulk_recover',
      'bulk_edit',
      'bulk_cancel',
      'bulk_message',
      'bulk_store',
      'bulk_subscription',
      'bulk_coupon',
      'pay',
      'export',
      'export_all',
    ];
    entities.forEach(entity => {
      actions.forEach(action => {
        profiles[0].permissions.push(AuthorizationHelper.getPermissionName(action, entity));
      });
    });
    return profiles;
  }
}
